<script setup>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import Diary from '@/Components/Diary.vue';

defineProps({
    diaries: Object,
});

</script>

<script>
export default {
    mounted(){
        document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-12.jpg') + '")';
        document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
        document.querySelector('section.page-header').style.backgroundSize = 'cover';
        document.querySelector('section.page-header').style.backgroundPosition = 'center';
    }
}
</script>

<template>
    <AppLayout title="Neighbourhood Diaries Inspire Properties" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Diaries</a></li>
                </ol>
            </nav>
            <div>
                <h2 class="page-header-heading">Neighbourhood Diaries</h2>
            </div>
        </template>

        <section class="neighbourhood-diaries">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="headings">
                            <h2>
                                Neighbourhood Diaries
                            </h2>
                            <p class="mt-3">
                                Inspire Properties specializes in the Luxury Residential and High-End Commercial Real Estate. Here are our Landmark segments
                            </p>
                        </div>
                    </div>
                </div>
                <div class="diaries-listing-wrap mt-5">
                    <div class="row">

                        <div class="col-lg-4 col-md-6 mb-5" v-for="diary in diaries" :key="diary.id">
                            <Diary :diary="diary"></Diary>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>

    </AppLayout>
</template>